import "./Header.scss";

function SearchResultsHeader({ count, term }) {
  return (
    <div className="bn-search__results-header">
      {count > 0 ? (
        <>
          Encontramos <span className="bn-search__result-count">{count}</span>{" "}
          itens para <span className="bn-search__result-term">{term}</span>
        </>
      ) : (
        <>
          Não encontramos produtos correspondentes à sua pesquisa por
          <span className="bn-search__result-term">{term}</span>
        </>
      )}
    </div>
  );
}

export default SearchResultsHeader;
